import React, { useEffect, useRef } from "react";
import Container from "Components/Container/Container";
import { Link } from "react-router-dom";

const Services = ({ data }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const items = entry.target.querySelectorAll(".overlay-services");
        const images = entry.target.querySelectorAll(".service-image");

        if (entry.isIntersecting) {
          items.forEach((item, index) => {
            setTimeout(() => {
              item.classList.add("-translate-y-full");

              setTimeout(() => {
                images[index].classList.add("grayscale");
              }, 500); // Adjust the timing as needed
            }, index * 500); // 500ms delay for each item
          });
        } else {
          // Reset animation when the section is not visible
          items.forEach((item) => {
            item.classList.remove("-translate-y-full");
          });
          images.forEach((image) => {
            image.classList.remove("grayscale");
          });
        }
      });
    }, options);

    observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-secondary lg:py-primary scroll-section flex items-center justify-center"
    >
      <Container>
        <div>
          <h2 className="title">Services</h2>
          <p className="sub_title w-1/2">{data?.title}</p>
        </div>

        <div className="flex flex-col md:flex-row mt-10">
          {data?.services_data?.map(({ title, background }, index) => (
            <Link
              key={index}
              to={"/services"}
              className="relative h-[300px] transition ease-in duration-300 lg:flex-1 text-white text-center flex items-center justify-center group overflow-hidden"
            >
              <div className="overlay-services absolute bottom-0 left-0 w-full h-full transition ease-in duration-300 duration-500 z-[100] bg-black hidden lg:block"></div>
              <img
                className={`service-image absolute transition ease-in duration-200 left-0 top-0 w-full h-full group-hover:scale-[1.1] hover:grayscale-0`}
                src={background}
                alt={title}
              />
              <p className="relative mb-6 text-2xl uppercase font-semibold transition ease-in duration-200 lg:opacity-0 lg:group-hover:translate-y-[0] lg:group-hover:opacity-100 lg:translate-y-[20px]">
                {title}
              </p>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Services;
